import storage from 'app/blocks/common/storage';
import { getUser } from 'app/blocks/middleware/user';

const PROXY_SESSION_KEYS = {
    LAST_PAGE: 'as__proxy-session-last-page',
    SESSION_ID: 'as__proxy-session-id',
    START: 'as__proxy-session-start',
};

export const storeLastPage = (page: string) => {
    storage.set(PROXY_SESSION_KEYS.LAST_PAGE, JSON.stringify(page));
};

export const getLastPage = () => {
    try {
        const pageString = storage.get(PROXY_SESSION_KEYS.LAST_PAGE);
        return JSON.parse(pageString);
    } catch (e) {
        return '';
    }
};

export const clearProxySessionData = () => {
    storage.remove(PROXY_SESSION_KEYS.SESSION_ID);
    storage.remove(PROXY_SESSION_KEYS.START);
    storage.remove(PROXY_SESSION_KEYS.LAST_PAGE);
};

export const updateProxySession = (sessionId: string) => {
    if (storage.get(PROXY_SESSION_KEYS.SESSION_ID) !== sessionId) {
        storage.set(PROXY_SESSION_KEYS.SESSION_ID, sessionId);
        storage.set(PROXY_SESSION_KEYS.START, new Date().getTime());
    }
};

const getProxySessionStart = () => storage.get(PROXY_SESSION_KEYS.START);

export const generateProxySessionData = (proxySessionEnd?: number) => {
    const user = getUser();
    return {
        'proxy-connect-id': user.imitateBy?.connectId,
        'proxy-session-end': proxySessionEnd,
        'proxy-session-id': storage.get(PROXY_SESSION_KEYS.SESSION_ID),
        'proxy-session-start': getProxySessionStart(),
    };
};

export const getProxySessionData = (): Object | undefined => {
    const user = getUser();
    if (user.isAdminMode && user.imitateBy) {
        return generateProxySessionData();
    }
    return undefined;
};
